import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { Icon } from '../Icon';
import { jsx as _jsx } from "react/jsx-runtime";
var UnderlineSvg = function UnderlineSvg() {
  return /*#__PURE__*/_jsx("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    children: /*#__PURE__*/_jsx("path", {
      fill: "#000",
      d: "M18.25 15.667V1h-1.5v14.667c0 .874-.709 1.583-1.583 1.583H8.833a1.583 1.583 0 0 1-1.583-1.583V1h-1.5v14.667a3.083 3.083 0 0 0 3.083 3.083h6.334a3.083 3.083 0 0 0 3.083-3.083M1 22.75h22v-1.5H1z"
    })
  });
};
export var Underline = function Underline(props) {
  return /*#__PURE__*/_jsx(Icon, _objectSpread(_objectSpread({}, props), {}, {
    component: UnderlineSvg
  }));
};